import type { Components } from '@mui/material/styles'

import type { Theme } from '../types'

export const MuiDateTimePickerToolbar = {
	styleOverrides: {
		root: {
			'& .MuiDateTimePickerToolbar-separator': {
				display: 'flex',
				alignItems: 'center',
				marginBottom: 1,
			},
		},
	},
} satisfies Components<Theme>['MuiDateTimePickerToolbar']
